module.exports = __webpack_public_path__ + "img/导购员名单.1477b25f.svg";